import { __require as requireShared } from './node_modules-core-js-internals-shared.js';
import { __require as requireUid } from './node_modules-core-js-internals-uid.js';

var sharedKey;
var hasRequiredSharedKey;

function requireSharedKey () {
	if (hasRequiredSharedKey) return sharedKey;
	hasRequiredSharedKey = 1;
	var shared = requireShared();
	var uid = requireUid();

	var keys = shared('keys');

	sharedKey = function (key) {
	  return keys[key] || (keys[key] = uid(key));
	};
	return sharedKey;
}

export { requireSharedKey as __require };
//# sourceMappingURL=node_modules-core-js-internals-shared-key.js.map
